import { Table } from 'antd';
import styled from 'styled-components';

import SvgIcon from '~src/shared/SvgIcon';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import { media } from '~src/styles/media-templates';

export const CycleContainerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 2rem 0 0 0;
`;

export const DeadlineContainer = styled.div`
  align-self: center;
  justify-self: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  font-size: 15px;
`;

export const DeadlineContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.7rem;
`;

export const DeadlineHeader = styled.span`
  font-size: 12px;
  text-align: left;
  color: ${({ theme }) => theme.baseBlue.a8};
`;

export const InputContainer = styled.div`
  width: 40%;
  padding: 1rem 0 1rem 20px;
  align-self: center;

  input {
    opacity: 1;
  }

  ${media.tablet`
    width: 100%;
    padding: 1rem 0 1rem 0;
  `}
`;

export const ButtonContainer = styled.div`
  width: 40%;
  padding: 0 2rem 0 2rem;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${({ theme }) => theme.black.a1};
  ${media.tablet`
    padding: 0 2rem 0 0;
    width: 50%;
  `}
`;

export const ButtonLogo = styled(SvgIcon)`
  margin-right: 5px;
`;

export const DateInputsWrapper = styled.div`
  padding: 0 2rem 0 2rem;
  display: flex;
  flex-direction: column;
  ${media.tablet`
    padding: 0 0 0 2rem;
  `}
`;

export const DateInputsContainer = styled.div`
  width: 70%;
  ${media.tablet`
    padding: 0;
    width: 60%;
  `}
`;

export const InputRow = styled.div<{ $active: boolean }>`
  display: ${({ $active }) => ($active ? 'flex' : 'none')};
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${media.tablet`
    flex-direction: column;
  `}
`;

export const InputSection = styled.div<{ $active: boolean; $disabled?: boolean }>`
  display: ${({ $active }) => ($active ? 'block' : 'none')};
  background: ${({ $disabled, theme }) => ($disabled ? theme.baseBlue.a1 : 'none')};
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
  &:nth-last-child(1) {
    border-bottom: none !important;
  }
`;

export const CycleWrapper = styled.div`
  align-items: center;
  padding: 2rem 2rem 2rem 2rem;
  border-top: 7px solid ${({ theme }) => theme.black.a1};
`;

export const PeriodMessage = styled.div<{ $active: boolean }>`
  display: ${({ $active }) => ($active ? 'block' : 'none')};
  width: 100%;
  padding: 20px 0;
  font-size: 0.83rem;
  line-height: 1.83;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a8};
  align-self: center;
`;

export const InputLabel = styled.div<{ $disabled?: boolean }>`
  width: 60%;
  color: ${({ theme, $disabled }) => ($disabled ? theme.baseBlue.a4 : theme.baseBlue.a8)};
  padding-bottom: 1rem;
  padding-top: 1rem;
  ${media.tablet`
    width: 100%;
    padding: 1rem 0 1rem 0;
  `}
`;

export const PeriodSelector = styled.div<{ $active: boolean; $disabled?: boolean }>`
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  margin-top: 20px;
  width: 100%;
  height: 66px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.white.a10};
  border: solid 2px ${({ theme }) => theme.baseBlue.a10};
  line-height: 3.5;
  padding: 0.4rem;
  text-align: center;
  font-size: 15px;
  opacity: ${({ $active }) => ($active ? '1' : '.35')};
  font-weight: 600;
  color: ${({ theme, $disabled }) => ($disabled ? theme.baseBlue.a4 : theme.baseBlue.a10)};
  transition: opacity 0.35s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  }
`;

export const CustomCycleInputsContainer = styled.div<{ $isCycleListEmpty?: boolean }>`
  padding: 0 2rem;
  width: 70%;
  margin: ${({ $isCycleListEmpty }) => ($isCycleListEmpty ? '0' : '1.3rem 0rem;')};
  display: flex;
  flex-direction: column;
  justify-content: ${({ $isCycleListEmpty }) => ($isCycleListEmpty ? 'center' : 'flex-start')};
  align-items: ${({ $isCycleListEmpty }) => ($isCycleListEmpty ? 'center' : 'flex-start')};
  ${media.tablet`
    padding: 0;
    width: 60%;
  `}
`;

export const TableStyled = styled(Table)``;

export const DueDateContainer = styled.div`
  display: flex;
`;

export const DueDateInfoIconContainer = styled.div`
  margin-left: 2rem;
`;

export const SecondaryButtonStyled = styled(SecondaryButton)`
  margin: 0.5rem;
  min-width: 210px;
`;